
import { HttpAttachmentRuleList, HttpDelAttachmentRule } from "@/service/ucadm";
import TableList from "@components/templates/tablelist";
import comClone from './comClone'
import mixin from '../mixin'
export default {
    mixins: [TableList, mixin],
    components: {
        comClone
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        }
    },
    methods: {
        ajaxRequest: HttpAttachmentRuleList,
        handleOperates(params, type) {
            switch (type) {
                case 'del':
                    this.operate = {
                        show: false,
                        alert: 'error',
                        params: { id: params },
                        title: '删除规则',
                        ajaxRequest: HttpDelAttachmentRule,
                    }
                    break
                case 'clone':
                    this.operate = {
                        show: true,
                        title: '规则克隆',
                        component: 'comClone',
                        id: params,
                        width: 400,
                        showFooter: false
                    }
                    break
            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: '查看',
                show: true,
                to: {
                    name: 'attachmentruleUpdate',
                    params: { type: 'query' },
                    query: { id },
                },
            }, {
                label: '编辑',
                show: true,
                to: {
                    name: 'attachmentruleUpdate',
                    params: { type: 'edit' },
                    query: { id },
                },
            }, {
                label: '删除',
                show: true,
                params: id,
                operate: 'del'
            }, {
                label: '克隆',
                show: true,
                params: id,
                operate: 'clone'
            }
            ]
        },
    },
    computed: {
        // ...mapGetters('dictionary', ['getProductList', 'getAccountList', 'getWarehouseList']),
        // ...mapGetters(['isSuper']),
        ToolsData() {
            return [
                {
                    label: '添加',
                    theme: 'primary',
                    to: {
                        name: 'attachmentruleUpdate',
                        params: { type: 'add' },
                    }
                },
            ]
        },
        SearchsData() {
            return [
                // {
                //     label: '规则名称',
                //     key: 'EQ_title',
                //     tag: 'vInput',
                //     show: true,
                // },
                {
                    label: '模块',
                    key: 'EQ_modelId',
                    tag: 'vSelect',
                    show: true,
                    options: this.getAttachmentModels
                },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    width: 110,
                    render: this.getOperateNodes
                }, {
                    title: 'ID',
                    key: 'id',
                    width: 70,
                },
                {
                    title: '环境类型',
                    key: 'envType',
                    render: (h, { row }) => this.findRenderLabel(this.getEnvTypes, row.envType),
                },
                {
                    title: '模块',
                    key: 'modelId',
                    render: (h, { row }) => this.findRenderLabel(this.getAttachmentModels, row.modelId),
                },
                {
                    title: '类型',
                    key: 'typeId',
                    render: (h, { row }) => this.findRenderLabel(this.getAttachmentTypes, row.typeId),
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                }, {
                    title: '更新时间',
                    key: 'updatedAt',
                }]
        },
    },
}




